module.exports = __webpack_public_path__ + "img/alentour25.12339154.jpg";